/// <reference path="../../../../typings/index.d.ts" />
///<reference path="yield-management-program.module.ts"/>


module Meevo.Plugins.YieldManagementProgram {
    import CoSearchResultsFilter = Meevo.Model.CoSearchResultsFilter;
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;
    import Messages = Meevo.Components.Common.Messages;
    import IYMStrategy = Meevo.Plugins.YieldManagementStrategy.IYMStrategy;
    import MemberStatusEnum = Meevo.Model.MemberStatusEnum;

    interface IYMStrategyRow extends IYMStrategy {
        id: string;
        isExpanded: boolean;
        programs?: IStrategyProgramItem[];
        height: number;
    }

    interface IStrategyProgramItem {
        homeLocationId: number;
        displayName_Strategy: string;
        strategyId: string;
        programId: string;
        displayName_Program: string;
        startDate: Date;
        memberStatusStr?: string;
        memberStatus: MemberStatusEnum;
        filterByClientType: number;
    }

    const programRowHeight = 50;
    const maxProgramsHeight = 200;

    class YieldManagementProgramController extends Meevo.Components.BaseClasses.DataMaintenanceControllerBase {

        static $inject = [
            'meevo.AppSettings',
            'meevo.components.common.DataService',
            'meevo.components.modal.ModalService',
            'meevo.components.common.IdentityService',
            'meevo.components.logging.LoggingService',
            'meevo.components.common.SecurityService',
            'meevo.components.tracking.TrackingService',
            '$rootScope',
            '$scope',
            '$state',
            'meevo.ContextParams',
            'meevo.components.short-cuts.ShortCutsService',
            'meevo.components.busy.BusyService',
            '$translate',
            '$filter',
            '$q',
        ];

        selectedStrategy: any;

        get searchNoun() {
            return Meevo.Model.NounEnum.YieldManagementProgramPage;
        }

        get objectStateEnum() {
            return ObjectStateEnum;
        }

        get locationId() {
            return this.identityService.current().locationId;
        }

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
                    protected dataService: Meevo.Components.BaseClasses.IDataService,
                    protected modalService: Meevo.Components.Modal.IModalService,
                    protected identityService: Meevo.Components.Common.IIdentityService,
                    protected loggingService: Meevo.Components.Logging.ILoggingService,
                    protected securityService: Meevo.Components.Common.ISecurityService,
                    protected trackingService: Meevo.Components.Tracking.ITrackingService,
                    protected $rootScope: angular.IRootScopeService,
                    protected $scope: angular.IScope,
                    protected $state: any,
                    protected contextParams: Meevo.IContextParams,
                    protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
                    protected busyService: Meevo.Components.Busy.IBusyService,
                    protected $translate: angular.translate.ITranslateService,
                    protected $filter: ng.IFilterService,
                    protected $q: ng.IQService,
        ) {

            super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService);

            this.checkStrategiesCount();
        }

        setStrategy(item: any) {
            this.selectedStrategy = item;
        }


        loadPrograms(item: IYMStrategyRow) {
            if (item.isExpanded) {
                item.isExpanded = false;
                return;
            }

            if (item.programs instanceof Array) {
                item.isExpanded = true;
                return;
            }

            this.busyService.start();
            this.dataService.getListPaged<IStrategyProgramItem, any>('YieldManagement/StrategyProgram', {
                criteria: {
                    strategyId: item.strategyId,
                    objectState: [ObjectStateEnum.Active, ObjectStateEnum.Inactive],
                    includeActive: true,
                    includeDeleted: true,
                    includeInactive: true,
                    isCOSearch: this.identityService.inCentralOfficeMode(),
                },
                pageNumber: 0,
                itemsPerPage: 1000,
                sortBy: 'displayName',
            }).then((list) => {
                list.forEach((row) => {
                    switch (row.memberStatus) {
                        case Meevo.Model.MemberStatusEnum.All:
                            row.memberStatusStr = 'LABEL_EVERYONE';
                            break;
                        case Meevo.Model.MemberStatusEnum.AllMembers:
                            row.memberStatusStr = 'LABEL_ONLY_MEMBER';
                            break;
                        case Meevo.Model.MemberStatusEnum.Member:
                            row.memberStatusStr = 'LABEL_ONLY_SPECIFIC_MEMBERSHIPS';
                            break;
                        case Meevo.Model.MemberStatusEnum.NonMember:
                            row.memberStatusStr = 'LABEL_ONLY_NON_MEMBER';
                            break;
                    }
                });

                item.programs = list;
                item.isExpanded = true;
                item.height = list.length * programRowHeight;

                if (item.height > maxProgramsHeight) {
                    item.height = maxProgramsHeight;
                }
            }).finally(() => {
                this.busyService.stop();
            });
        }

        checkStrategiesCount() {
            this.busyService.start();
            this.dataService.getCount(this.appSettings.API_ENDPOINTS.yieldManagementStrategy, {
                criteria: {
                    objectState: ObjectStateEnum.Active
                },
            }).then((count) => {
                if (count === 0) {
                    this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state['current'], null);
                    this.modalService
                        .yellowConfirm('LABEL_ZERO_STRATEGY_CONFIRM')
                        .then(() => {
                            this.$rootScope.$broadcast(Messages.GOTO_STATE, {
                                stateName: this.appSettings.ROUTE_NAMES.yieldManagementStrategy,
                                stateParams: {}
                            });
                        });
                }
            }).finally(() => {
                this.busyService.stop();
            });
        }


        /**
         * Creates the context for editing/adding an item.
         */
        createContext(): void {
            this.busyService.start();
            this.securityService.checkSection(this.meevoSecurityKeys.MANAGEMENT_YIELDMANAGEMENTPROGRAM).then(() => {
                this.busyService.stop();
                this.context = new YieldManagementProgramContext(
                    this.appSettings,
                    this.dataService,
                    this.modalService,
                    this.identityService,
                    this.loggingService,
                    this.securityService,
                    this.trackingService,
                    this.$scope,
                    this.$filter,
                    this.$q,
                    this.busyService,
                );
                for (const section of this.context.sections) {
                    (section as any).selectedStrategy = this.selectedStrategy;
                }
                this.context.activate(this.selectedItemId, null, this.asLocationId);
                this.context.deactivate = () => {
                    this.selectedItemId = null;
                    this.visualState = Model.MaintenanceFormVisualState.Search;
                };
            }).catch(() => {
                this.busyService.stop();
            });
        }
    }

    angular.module('meevo.plugins.yieldManagementProgram')
        .controller('meevo.plugins.yieldManagementProgram.YieldManagementProgramController', YieldManagementProgramController);
}
